// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_927a99ad28--wrapper--HIFCI","title":"_927a99ad28--title--l59eQ","icon":"_927a99ad28--icon--FJyZ5"};